import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import * as Colors from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface TriangleToggleProps {
  toggleLabel: string;
  children: JSX.Element;
  isCollapsed: boolean;
  setIsCollapsed: (isCollapsed: boolean) => void;
}

export default function TriangleToggle(props: TriangleToggleProps): JSX.Element {
  return (
    <>
      <div
        onClick={() => {
          props.setIsCollapsed(!props.isCollapsed);
        }}
        className={classNames(css(styles.toggleLabel), 'u-mini-spacing-top')}
      >
        {props.isCollapsed ? (
          <BenchlingIcon className={css(styles.toggleIcon)} icon="triangle-right" />
        ) : (
          <BenchlingIcon className={css(styles.toggleIcon)} icon="triangle-down" />
        )}
        {props.toggleLabel}
      </div>
      {!props.isCollapsed && props.children}
    </>
  );
}

const styles = StyleSheet.create({
  toggleIcon: {
    color: Colors.GRAY_DARKER,
    flex: 'none',
  },
  toggleLabel: {
    cursor: 'pointer',
  },
});
